import React, { useEffect, useState } from 'react';
import { console_ } from '../services/api';
import { dateFr, dateHeureFr, n } from '../services/format';
import { Erreur, Chargement, messageErreur } from './Ui';

// Configuration (admin) : sociétés responsables, finalités, clés API des
// applications consommatrices, habilitations, import a97_data, tâches.
export default function Configuration({ user }) {
  const [config, setConfig] = useState(null);
  const [erreur, setErreur] = useState('');
  const [message, setMessage] = useState('');
  const charger = () => console_.config().then((r) => setConfig(r.data)).catch((e) => setErreur(messageErreur(e)));
  useEffect(() => { charger(); }, []);
  const agir = async (fn, msg) => {
    try { const r = await fn(); setErreur(''); setMessage(typeof msg === 'function' ? msg(r?.data) : msg); charger(); return r; } catch (e) { setErreur(messageErreur(e)); return null; }
  };
  if (erreur && !config) return <Erreur message={erreur} />;
  if (!config) return <Chargement />;
  return (
    <div>
      <h1 className="rg-titre-page">Configuration</h1>
      {message && <div className="rg-succes">{message}</div>}
      <Erreur message={erreur} />
      <p className="rg-info" style={{ marginBottom: 16 }}>Modes d'envoi globaux (variables d'environnement) : SMS <strong>{config.modes.sms}</strong> · e-mail <strong>{config.modes.email}</strong>.</p>
      <Societes societes={config.societes} agir={agir} />
      <Finalites finalites={config.finalites} agir={agir} />
      <Cles cles={config.cles} agir={agir} />
      <Habilitations habilitations={config.habilitations} agir={agir} moi={user.email} />
      <Import disponible={config.import.disponible} societes={config.societes} agir={agir} />
      <Taches agir={agir} />
    </div>
  );
}

function Societes({ societes, agir }) {
  const [edit, setEdit] = useState(null);
  const [nouvelle, setNouvelle] = useState(null);
  const enregistrer = async (e) => {
    e.preventDefault();
    const { id, ...corps } = edit;
    if (await agir(() => console_.modifierSociete(id, corps), 'Société enregistrée.')) setEdit(null);
  };
  const creer = async (e) => {
    e.preventDefault();
    if (await agir(() => console_.creerSociete(nouvelle), 'Société créée.')) setNouvelle(null);
  };
  return (
    <section className="rg-section">
      <h2>Sociétés responsables de traitement<small>{societes.length}</small></h2>
      <div className="rg-defile">
        <table className="rg-tableau">
          <thead><tr><th>Code</th><th>codsoc</th><th>Raison sociale</th><th>Marque / zone</th><th>E-mail DPO</th><th>Politique</th><th>Actif</th><th></th></tr></thead>
          <tbody>
            {societes.map((s) => (
              <tr key={s.id}>
                <td className="rg-mono">{s.code}</td><td>{s.codsoc || '—'}</td><td>{s.raison_sociale}</td><td>{s.marque || '—'}</td><td>{s.dpo_email || <span className="rg-info">à renseigner</span>}</td>
                <td>{s.politique_url ? <a href={s.politique_url} target="_blank" rel="noreferrer">lien</a> : '—'}</td>
                <td>{s.actif ? 'oui' : 'non'}</td>
                <td><button className="rg-btn" onClick={() => setEdit({ id: s.id, raison_sociale: s.raison_sociale, marque: s.marque || '', dpo_email: s.dpo_email || '', adresse: s.adresse || '', politique_url: s.politique_url || '', actif: s.actif })}>Modifier</button></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {edit && (
        <form className="rg-bloc rg-form" style={{ marginTop: 12 }} onSubmit={enregistrer}>
          <h3>Modifier la société</h3>
          <div className="rg-ligne">
            <label>Raison sociale<input value={edit.raison_sociale} onChange={(e) => setEdit({ ...edit, raison_sociale: e.target.value })} required /></label>
            <label>Marque / zone<input value={edit.marque} onChange={(e) => setEdit({ ...edit, marque: e.target.value })} /></label>
            <label>E-mail DPO (affiché aux clients)<input type="email" value={edit.dpo_email} onChange={(e) => setEdit({ ...edit, dpo_email: e.target.value })} /></label>
          </div>
          <div className="rg-ligne">
            <label>Adresse<input value={edit.adresse} onChange={(e) => setEdit({ ...edit, adresse: e.target.value })} /></label>
            <label>URL politique de confidentialité<input value={edit.politique_url} onChange={(e) => setEdit({ ...edit, politique_url: e.target.value })} /></label>
            <label>Actif<select value={edit.actif ? '1' : '0'} onChange={(e) => setEdit({ ...edit, actif: e.target.value === '1' })}><option value="1">oui</option><option value="0">non</option></select></label>
          </div>
          <div className="rg-actions"><button className="rg-btn rg-btn--principal">Enregistrer</button><button type="button" className="rg-btn" onClick={() => setEdit(null)}>Annuler</button></div>
        </form>
      )}
      <div className="rg-actions">{!nouvelle && <button className="rg-btn" onClick={() => setNouvelle({ code: '', codsoc: '', raison_sociale: '', marque: '' })}>+ Ajouter une société</button>}</div>
      {nouvelle && (
        <form className="rg-bloc rg-form" style={{ marginTop: 12 }} onSubmit={creer}>
          <div className="rg-ligne">
            <label>Code<input value={nouvelle.code} onChange={(e) => setNouvelle({ ...nouvelle, code: e.target.value })} required /></label>
            <label>codsoc Datacar<input value={nouvelle.codsoc} onChange={(e) => setNouvelle({ ...nouvelle, codsoc: e.target.value })} /></label>
            <label>Raison sociale<input value={nouvelle.raison_sociale} onChange={(e) => setNouvelle({ ...nouvelle, raison_sociale: e.target.value })} required /></label>
            <label>Marque / zone<input value={nouvelle.marque} onChange={(e) => setNouvelle({ ...nouvelle, marque: e.target.value })} /></label>
          </div>
          <div className="rg-actions"><button className="rg-btn rg-btn--principal">Créer</button><button type="button" className="rg-btn" onClick={() => setNouvelle(null)}>Annuler</button></div>
        </form>
      )}
    </section>
  );
}

function Finalites({ finalites, agir }) {
  const [edit, setEdit] = useState(null);
  const enregistrer = async (e) => {
    e.preventDefault();
    const { code, ...corps } = edit;
    if (await agir(() => console_.modifierFinalite(code, { ...corps, validite_mois: Number(corps.validite_mois) }), 'Finalité enregistrée.')) setEdit(null);
  };
  return (
    <section className="rg-section">
      <h2>Finalités<small>durée de validité et exception « client existant »</small></h2>
      <div className="rg-defile">
        <table className="rg-tableau">
          <thead><tr><th>Code</th><th>Libellé</th><th>Canal</th><th>Base légale</th><th className="rg-num">Validité (mois)</th><th>Exception client</th><th>Actif</th><th></th></tr></thead>
          <tbody>
            {finalites.map((f) => (
              <tr key={f.code}>
                <td className="rg-mono">{f.code}</td><td>{f.libelle}</td><td>{f.canal}</td><td>{f.base_legale_defaut}</td><td className="rg-num">{f.validite_mois}</td>
                <td>{f.exception_client_existant ? 'oui' : 'non'}</td><td>{f.actif ? 'oui' : 'non'}</td>
                <td><button className="rg-btn" onClick={() => setEdit({ code: f.code, libelle: f.libelle, description: f.description || '', validite_mois: f.validite_mois, exception_client_existant: f.exception_client_existant, actif: f.actif })}>Modifier</button></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {edit && (
        <form className="rg-bloc rg-form" style={{ marginTop: 12 }} onSubmit={enregistrer}>
          <h3>Modifier « {edit.code} »</h3>
          <label>Libellé<input value={edit.libelle} onChange={(e) => setEdit({ ...edit, libelle: e.target.value })} required /></label>
          <div className="rg-ligne">
            <label>Validité (mois)<input type="number" min="1" value={edit.validite_mois} onChange={(e) => setEdit({ ...edit, validite_mois: e.target.value })} /></label>
            <label>Exception client existant<select value={edit.exception_client_existant ? '1' : '0'} onChange={(e) => setEdit({ ...edit, exception_client_existant: e.target.value === '1' })}><option value="0">non</option><option value="1">oui</option></select></label>
            <label>Actif<select value={edit.actif ? '1' : '0'} onChange={(e) => setEdit({ ...edit, actif: e.target.value === '1' })}><option value="1">oui</option><option value="0">non</option></select></label>
          </div>
          <p className="rg-info">Téléphone : 12 mois (loi 2025-594), sans exception client (seul un contrat en cours déclaré sur la relation autorise l'appel). SMS / e-mail : 36 mois glissants, exception client existant possible.</p>
          <div className="rg-actions"><button className="rg-btn rg-btn--principal">Enregistrer</button><button type="button" className="rg-btn" onClick={() => setEdit(null)}>Annuler</button></div>
        </form>
      )}
    </section>
  );
}

function Cles({ cles, agir }) {
  const [nouvelle, setNouvelle] = useState(null);
  const [affichee, setAffichee] = useState(null);
  const creer = async (e) => {
    e.preventDefault();
    const r = await agir(() => console_.creerCle(nouvelle), 'Clé créée : copiez-la maintenant, elle ne sera plus affichée.');
    if (r) { setAffichee(r.data); setNouvelle(null); }
  };
  const basculer = (p) => setNouvelle({ ...nouvelle, portees: nouvelle.portees.includes(p) ? nouvelle.portees.filter((x) => x !== p) : [...nouvelle.portees, p] });
  return (
    <section className="rg-section">
      <h2>Clés API<small>applications consommatrices (CRM, hub, BI…)</small></h2>
      {affichee && (
        <div className="rg-cle-affichee">
          <strong>{affichee.nom}</strong> ({affichee.application}) — à placer dans <code>CONSENT_API_KEY</code> :
          <div className="rg-mono" style={{ fontSize: 14, marginTop: 6 }}>{affichee.cle}</div>
          <button className="rg-btn" style={{ marginTop: 8 }} onClick={() => setAffichee(null)}>J'ai copié la clé</button>
        </div>
      )}
      <div className="rg-defile">
        <table className="rg-tableau">
          <thead><tr><th>Nom</th><th>Application</th><th>Préfixe</th><th>Portées</th><th>Dernière utilisation</th><th>Active</th><th></th></tr></thead>
          <tbody>
            {cles.map((c) => (
              <tr key={c.id}>
                <td>{c.nom}</td><td>{c.application}</td><td className="rg-mono">rgpd_{c.prefixe}_…</td><td>{(c.portees || []).join(', ')}</td>
                <td>{c.derniere_utilisation ? dateHeureFr(c.derniere_utilisation) : 'jamais'}</td><td>{c.actif ? 'oui' : 'non'}</td>
                <td><button className={`rg-btn ${c.actif ? 'rg-btn--danger' : ''}`} onClick={() => agir(() => console_.modifierCle(c.id, !c.actif), c.actif ? 'Clé révoquée.' : 'Clé réactivée.')}>{c.actif ? 'Révoquer' : 'Réactiver'}</button></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="rg-actions">{!nouvelle && <button className="rg-btn" onClick={() => setNouvelle({ nom: '', application: 'crm', portees: ['verifier'] })}>+ Nouvelle clé</button>}</div>
      {nouvelle && (
        <form className="rg-bloc rg-form" style={{ marginTop: 12 }} onSubmit={creer}>
          <div className="rg-ligne">
            <label>Nom<input value={nouvelle.nom} onChange={(e) => setNouvelle({ ...nouvelle, nom: e.target.value })} required placeholder="CRM prod" /></label>
            <label>Application<input value={nouvelle.application} onChange={(e) => setNouvelle({ ...nouvelle, application: e.target.value })} required /></label>
          </div>
          <div className="rg-cases">{['verifier', 'ecrire', 'demander'].map((p) => <label key={p}><input type="checkbox" checked={nouvelle.portees.includes(p)} onChange={() => basculer(p)} /> {p}</label>)}</div>
          <p className="rg-info">verifier = « ai-je le droit ? » ; ecrire = consentements et oppositions recueillis ailleurs ; demander = envoyer un formulaire.</p>
          <div className="rg-actions"><button className="rg-btn rg-btn--principal" disabled={!nouvelle.portees.length}>Créer</button><button type="button" className="rg-btn" onClick={() => setNouvelle(null)}>Annuler</button></div>
        </form>
      )}
    </section>
  );
}

function Habilitations({ habilitations, agir, moi }) {
  const [nouvelle, setNouvelle] = useState(null);
  const creer = async (e) => {
    e.preventDefault();
    if (await agir(() => console_.creerHabilitation(nouvelle), 'Habilitation enregistrée.')) setNouvelle(null);
  };
  return (
    <section className="rg-section">
      <h2>Habilitations<small>admin = responsable RGPD · dpo = lecture, journal, exports · operateur = recueil et demandes</small></h2>
      <div className="rg-defile">
        <table className="rg-tableau">
          <thead><tr><th>E-mail</th><th>Nom</th><th>Rôle</th><th>Dernière connexion</th><th>Actif</th><th></th></tr></thead>
          <tbody>
            {habilitations.map((h) => (
              <tr key={h.id}>
                <td>{h.email}</td><td>{[h.prenom, h.nom].filter(Boolean).join(' ') || '—'}</td>
                <td><select value={h.role} disabled={h.email === moi} onChange={(e) => agir(() => console_.modifierHabilitation(h.id, { role: e.target.value }), 'Rôle modifié.')} style={{ padding: 4 }}><option value="admin">admin</option><option value="dpo">dpo</option><option value="operateur">operateur</option></select></td>
                <td>{h.derniere_connexion ? dateHeureFr(h.derniere_connexion) : 'jamais'}</td><td>{h.actif ? 'oui' : 'non'}</td>
                <td>{h.email !== moi && <button className={`rg-btn ${h.actif ? 'rg-btn--danger' : ''}`} onClick={() => agir(() => console_.modifierHabilitation(h.id, { actif: !h.actif }), h.actif ? 'Accès désactivé.' : 'Accès réactivé.')}>{h.actif ? 'Désactiver' : 'Réactiver'}</button>}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="rg-actions">{!nouvelle && <button className="rg-btn" onClick={() => setNouvelle({ email: '', nom: '', prenom: '', role: 'operateur' })}>+ Ajouter un accès</button>}</div>
      {nouvelle && (
        <form className="rg-bloc rg-form" style={{ marginTop: 12 }} onSubmit={creer}>
          <div className="rg-ligne">
            <label>E-mail Microsoft<input type="email" value={nouvelle.email} onChange={(e) => setNouvelle({ ...nouvelle, email: e.target.value })} required /></label>
            <label>Prénom<input value={nouvelle.prenom} onChange={(e) => setNouvelle({ ...nouvelle, prenom: e.target.value })} /></label>
            <label>Nom<input value={nouvelle.nom} onChange={(e) => setNouvelle({ ...nouvelle, nom: e.target.value })} /></label>
            <label>Rôle<select value={nouvelle.role} onChange={(e) => setNouvelle({ ...nouvelle, role: e.target.value })}><option value="operateur">operateur</option><option value="dpo">dpo</option><option value="admin">admin</option></select></label>
          </div>
          <div className="rg-actions"><button className="rg-btn rg-btn--principal">Enregistrer</button><button type="button" className="rg-btn" onClick={() => setNouvelle(null)}>Annuler</button></div>
        </form>
      )}
    </section>
  );
}

function Import({ disponible, societes, agir }) {
  const [apercu, setApercu] = useState(null);
  const [societe, setSociete] = useState('');
  const [limite, setLimite] = useState('');
  const [etat, setEtat] = useState(null);
  const voir = async () => { const r = await agir(() => console_.apercuImport(), 'Aperçu chargé.'); if (r) setApercu(r.data); };
  const rafraichir = () => console_.etatImport().then((r) => setEtat(r.data)).catch(() => {});
  // L'import tourne en arrière-plan côté serveur : on suit l'avancement.
  useEffect(() => {
    rafraichir();
    if (!etat?.en_cours) return undefined;
    const t = setInterval(rafraichir, 3000);
    return () => clearInterval(t);
  }, [etat?.en_cours]); // eslint-disable-line react-hooks/exhaustive-deps
  const lancer = async () => {
    if (!window.confirm('Importer les contacts du mart a97_data (identifiants + relations, sans consentement) ?')) return;
    const r = await agir(() => console_.importer({ societe: societe || undefined, limite: limite ? Number(limite) : undefined }), 'Import lancé en arrière-plan.');
    if (r) rafraichir();
  };
  const bilan = etat?.dernier;
  const enCours = etat?.en_cours;
  return (
    <section className="rg-section">
      <h2>Import a97_data<small>mart marts.contacts_rgpd → identifiants et relations</small></h2>
      {!disponible ? <p className="rg-info">Pont a97_data non configuré (DATA_DB_HOST).</p> : (
        <>
          <div className="rg-actions" style={{ marginTop: 0, alignItems: 'center' }}>
            <button className="rg-btn" onClick={voir}>Aperçu du mart</button>
            <select value={societe} onChange={(e) => setSociete(e.target.value)} style={{ padding: 8 }}><option value="">Toutes les sociétés</option>{societes.map((s) => <option key={s.id} value={s.code}>{s.raison_sociale}</option>)}</select>
            <input type="number" min="1" placeholder="limite" value={limite} onChange={(e) => setLimite(e.target.value)} style={{ width: 100, padding: 8 }} />
            <button className="rg-btn rg-btn--principal" onClick={lancer}>Importer</button>
          </div>
          {apercu && (
            <table className="rg-tableau" style={{ marginTop: 12 }}>
              <thead><tr><th>Périmètre</th><th>Codsoc</th><th>Site</th><th>Type</th><th>Relation</th><th className="rg-num">N</th><th>Dernière date</th></tr></thead>
              <tbody>{apercu.map((a, i) => <tr key={i}><td>{a.perimetre}</td><td className="rg-mono">{a.codsoc}</td><td>{a.site || '—'}</td><td>{a.type}</td><td>{a.relation}</td><td className="rg-num">{n(a.n)}</td><td>{dateFr(a.derniere)}</td></tr>)}</tbody>
            </table>
          )}
          {enCours && <p className="rg-info">Import en cours{enCours.societe ? ` (${enCours.societe})` : ''} : {n(enCours.traites)} / {n(enCours.lus)} lignes traitées…</p>}
          {bilan && !enCours && (bilan.erreur
            ? <p className="rg-info">Dernier import en échec ({dateFr(bilan.termine_le)}) : {bilan.erreur}</p>
            : <p className="rg-info">Dernier import ({dateFr(bilan.termine_le)}) : lus {n(bilan.lus)} · identifiants créés {n(bilan.identifiants_crees)} · personnes créées {n(bilan.personnes_creees)} · relations {n(bilan.relations)} · invalides {n(bilan.invalides)} · société inconnue {n(bilan.societe_inconnue)}</p>)}
        </>
      )}
    </section>
  );
}

function Taches({ agir }) {
  const [resultat, setResultat] = useState(null);
  const taches = [['expirer', 'Expirer les accords arrivés à échéance'], ['expirerDemandes', 'Clore les demandes expirées'], ['sceller', 'Poser le sceau de la veille'], ['renouveler', 'Demandes de renouvellement J-30 + relances'], ['campagnes', 'Exécuter les campagnes actives'], ['purger', 'Purger les identifiants inactifs depuis 36 mois']];
  const lancer = async (nom) => { const r = await agir(() => console_.tache(nom), `Tâche « ${nom} » exécutée.`); if (r) setResultat({ nom, r: r.data }); };
  return (
    <section className="rg-section">
      <h2>Tâches planifiées<small>exécutées chaque jour à 07:30 ; lancement manuel possible</small></h2>
      <div className="rg-actions" style={{ marginTop: 0 }}>{taches.map(([nom, lib]) => <button key={nom} className="rg-btn" title={lib} onClick={() => lancer(nom)}>{nom}</button>)}</div>
      {resultat && <p className="rg-mono" style={{ marginTop: 10 }}>{resultat.nom} → {JSON.stringify(resultat.r)}</p>}
    </section>
  );
}
